import { Box, Container, Typography } from '@mui/material';
import { useThemeMode } from '../context/ThemeContext';

export default function PrivacyPolicy() {
  const { colors } = useThemeMode();

  return (
    <Box sx={{ bgcolor: colors.bgDefault, minHeight: '100vh', py: 8 }}>
      <Container maxWidth="md">
        <Typography variant="h3" sx={{ color: colors.textPrimary, fontWeight: 700, mb: 3 }}>
          Politique de confidentialité
        </Typography>

        <Typography variant="body1" sx={{ color: colors.textSecondary, mb: 3, lineHeight: 1.8 }}>
          Dernière mise à jour : juin 2026
        </Typography>

        <Typography variant="h5" sx={{ color: colors.textPrimary, fontWeight: 600, mb: 1.5, mt: 4 }}>
          1. Données collectées
        </Typography>
        <Typography variant="body1" sx={{ color: colors.textSecondary, mb: 2, lineHeight: 1.8 }}>
          Publy Music collecte les données strictement nécessaires au fonctionnement du service :
          adresse email, nom d'utilisateur, informations relatives aux déclarations SACEM
          (titre, ayants droit, répartition), et données de paiement (traitées par Stripe, jamais stockées sur nos serveurs).
        </Typography>

        <Typography variant="h5" sx={{ color: colors.textPrimary, fontWeight: 600, mb: 1.5, mt: 4 }}>
          2. Finalité du traitement
        </Typography>
        <Typography variant="body1" sx={{ color: colors.textSecondary, mb: 2, lineHeight: 1.8 }}>
          Vos données sont utilisées uniquement pour : générer vos documents SACEM,
          permettre la signature électronique, gérer votre abonnement, et vous contacter
          en cas de besoin lié à votre compte.
        </Typography>

        <Typography variant="h5" sx={{ color: colors.textPrimary, fontWeight: 600, mb: 1.5, mt: 4 }}>
          3. Partage des données
        </Typography>
        <Typography variant="body1" sx={{ color: colors.textSecondary, mb: 2, lineHeight: 1.8 }}>
          Vos données ne sont jamais revendues. Elles peuvent être transmises à nos
          sous-traitants techniques (hébergement AWS, signature Universign, paiement Stripe)
          dans le cadre strict de l'exécution du service.
        </Typography>

        <Typography variant="h5" sx={{ color: colors.textPrimary, fontWeight: 600, mb: 1.5, mt: 4 }}>
          4. Durée de conservation
        </Typography>
        <Typography variant="body1" sx={{ color: colors.textSecondary, mb: 2, lineHeight: 1.8 }}>
          Vos données sont conservées pendant la durée de votre compte actif, puis supprimées
          dans un délai de 30 jours après la clôture, sauf obligation légale de conservation.
        </Typography>

        <Typography variant="h5" sx={{ color: colors.textPrimary, fontWeight: 600, mb: 1.5, mt: 4 }}>
          5. Vos droits
        </Typography>
        <Typography variant="body1" sx={{ color: colors.textSecondary, mb: 2, lineHeight: 1.8 }}>
          Conformément au RGPD, vous disposez d'un droit d'accès, de rectification,
          de suppression et de portabilité de vos données. Contactez-nous à
          contact@publymusic.fr pour exercer ces droits.
        </Typography>
      </Container>
    </Box>
  );
}
